// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR = "Baz\u00e1r";
export const BLOGS = "Pr\u00edspevky";
export const HOMEPAGE_FEED_NAV_TAB_FORUM = "Diskusie";
export const MAIN_MENU_REVIEWS = "Recenzie";
export const TAB_GROUPS = "Skupiny";
